let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4VtVR")).then(() => parcelRequire('eOWtA'));